import { Grid, InputNumber, Span } from "@goodfill/ui-components";
import { Controller, useFormContext } from "react-hook-form";
import { FieldGroup } from "../../../../../../form/FieldGroup";
import { numberFormat } from "../../../../../../number/numberFormat";
import { CustomerApplicationFormState } from "../../../formState/formState";
import { InvestmentObjectives } from "./InvestmentObjectives";
import { SourcesOfWealthRows } from "./SourcesOfWealthRows";

export const Step5Financial = ({ areAllDisabled }: { areAllDisabled: boolean }) => {
  const { control } = useFormContext<CustomerApplicationFormState>();

  return (
    <div className="flex flex-col px-4 md:px-8 py-4 md:py-8 border-b border-neutral-110 items-center">
      <Span size="xl" uppercase={false} font="semibold">
        Financial information
      </Span>

      <Span className="Steps_welcomeMessage" wrap={true}>
        To open a free account and start you investing safely, we need to know more about you. Let's get started!
      </Span>

      <div className="flex w-full">
        <Controller
          render={({ field, fieldState: { error } }) => (
            <InvestmentObjectives
              onChange={field.onChange}
              value={field.value ?? []}
              validation={error?.message ? [error.message] : []}
              onBlur={field.onBlur}
              ref={field.ref}
              id={"investmentObjectives"}
              disabled={areAllDisabled}
            />
          )}
          name="step5.investmentObjectives"
          control={control}
        />
      </div>

      <Grid cols={2} gap={0.75} className="w-full">
        <Controller
          render={({ field, fieldState: { error } }) => (
            <FieldGroup
              label="Annual Net Income"
              validation={error?.message ? [error.message] : []}
              className="w-80-sm w-full-after-md"
              fill
            >
              <InputNumber
                placeholder="Enter amount"
                value={field.value}
                setValue={field.onChange}
                border={error === undefined ? "neutral" : "red"}
                onBlur={field.onBlur}
                ref={field.ref}
                id="annualNetIncome"
                formatValue={numberFormat}
                leftIcon="$"
                disabled={areAllDisabled}
              />
            </FieldGroup>
          )}
          name="step5.annualNetIncome"
          control={control}
        />

        <Controller
          render={({ field, fieldState: { error } }) => (
            <FieldGroup
              label="Liquid Net Worth"
              validation={error?.message ? [error.message] : []}
              className="w-80-sm w-full-after-md"
              fill
            >
              <InputNumber
                placeholder="Enter amount"
                value={field.value}
                setValue={field.onChange}
                border={error === undefined ? "neutral" : "red"}
                onBlur={field.onBlur}
                ref={field.ref}
                id="liquidNetWorth"
                formatValue={numberFormat}
                leftIcon="$"
                disabled={areAllDisabled}
              />
            </FieldGroup>
          )}
          name="step5.liquidNetWorth"
          control={control}
        />

        <Controller
          render={({ field, fieldState: { error } }) => (
            <FieldGroup
              label="Net Worth"
              validation={error?.message ? [error.message] : []}
              className="w-80-sm w-full-after-md"
              fill
            >
              <InputNumber
                placeholder="Enter amount"
                value={field.value}
                setValue={field.onChange}
                border={error === undefined ? "neutral" : "red"}
                onBlur={field.onBlur}
                ref={field.ref}
                id="netWorth"
                formatValue={numberFormat}
                leftIcon="$"
                disabled={areAllDisabled}
              />
            </FieldGroup>
          )}
          name="step5.netWorth"
          control={control}
        />
      </Grid>

      <Span size="xl" uppercase={false} font="semibold" className="mt-8">
        Source of Wealth
      </Span>

      <div className="flex flex-col my-1 md:my-2 py-1 md:py-2 w-full">
        <SourcesOfWealthRows areAllDisabled={areAllDisabled} />
      </div>
    </div>
  );
};
